import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const LegalNotice = () => {
  return (
    <main className="min-h-screen bg-background pt-24 pb-16">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Aviso Legal</h1>
          
          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm">Última actualización: {new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">1. Datos identificativos</h2>
              <p>
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la
                Sociedad de la Información y Comercio Electrónico, se informa:
              </p>
              <p>
                <strong>Titular:</strong> Jon Quintano Fotografía<br />
                <strong>Domicilio:</strong> Gamonal, 09007 Burgos, España<br />
                <strong>Email:</strong> info@jonquintano.com<br />
                <strong>Actividad:</strong> Servicios de fotografía profesional
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">2. Objeto</h2>
              <p>
                El presente sitio web tiene por objeto facilitar información sobre los servicios
                de fotografía profesional ofrecidos, así como permitir el contacto con potenciales
                clientes y la gestión de clientes existentes.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">3. Propiedad intelectual</h2>
              <p>
                Todos los contenidos de este sitio web, incluyendo textos, fotografías, gráficos,
                imágenes, iconos, tecnología, software, así como su diseño gráfico y códigos fuente,
                constituyen una obra cuya propiedad pertenece a Jon Quintano Fotografía.
              </p>
              <p>
                Quedan reservados todos los derechos. Está prohibida la reproducción, distribución,
                comunicación pública o transformación de cualquier contenido sin autorización expresa.
              </p>
              <p>
                <strong>Las fotografías mostradas en este sitio web están protegidas por derechos de autor.</strong>
                Queda expresamente prohibida su descarga, copia, reproducción o uso sin autorización previa y por escrito.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">4. Condiciones de uso</h2>
              <p>El usuario se compromete a:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>No utilizar el sitio web para fines ilícitos o contrarios a la buena fe.</li>
                <li>No intentar acceder a áreas restringidas sin autorización.</li>
                <li>No introducir virus o código malicioso.</li>
                <li>No suplantar la identidad de otros usuarios.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">5. Exclusión de responsabilidad</h2>
              <p>
                Jon Quintano Fotografía no se hace responsable de los daños y perjuicios que pudieran
                derivarse del uso del sitio web, incluyendo errores u omisiones en los contenidos,
                falta de disponibilidad del sitio o transmisión de virus.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">6. Enlaces externos</h2>
              <p>
                Este sitio web puede contener enlaces a sitios de terceros. Jon Quintano Fotografía
                no se responsabiliza del contenido, veracidad o funcionamiento de estos sitios externos.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">7. Modificaciones</h2>
              <p>
                Nos reservamos el derecho de modificar el contenido de este aviso legal en cualquier
                momento. Se recomienda revisar periódicamente esta página.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-foreground">8. Legislación aplicable</h2>
              <p>
                Este aviso legal se rige por la legislación española. Para cualquier controversia
                derivada del uso de este sitio web, las partes se someten a los juzgados y tribunales
                de Burgos, España.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default LegalNotice;
